import { useContext } from 'react';

import { Context } from './context';

export const useToast = () => useContext(Context);
